import React, { Fragment, ReactElement } from 'react';

import {
  Button,
  ButtonPattern,
  Container,
  Grid,
  GridItem,
  Text,
  Notification,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';

import { IdvErrorPageContent } from './IdvErrorPageContent';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';

function IdvErrorPage(): ReactElement {
  const { idvErrorPageContent } = useContent<IdvErrorPageContent>();
  const navigate = useNavigate();

  return (
    <Container padding="none">
      {idvErrorPageContent &&
        idvErrorPageContent.map(
          ({ serviceName, header, errorText, btnLabel, btnLink }) => (
            <Fragment key="call-us-content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="left" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Notification sentiment="critical">
                      <Text size="s2">{errorText}</Text>
                    </Notification>

                    <ButtonPattern marginBottom="none">
                      <Button
                        onClick={() => navigate(btnLink)}
                        iconPosition="right"
                      >
                        {btnLabel}
                      </Button>
                    </ButtonPattern>
                  </StyledBox>
                </GridItem>
              </Grid>
            </Fragment>
          ),
        )}
    </Container>
  );
}

export default IdvErrorPage;
